export const createDataAttr = (value: string) => {
  return {
    [`data-ams`]: value,
  };
};
